import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ErrorPageComponent } from './error-page.component';

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [ErrorPageComponent],
  exports: [ErrorPageComponent],
})
export class ErrorPageModule {}
